import { useWindowSize } from './useWindowSize';
import { DESKTOP_BREAKPOINT } from '~/constants';

export const useMobileWidth = (): boolean => {
  const { width: windowWidth } = useWindowSize();

  return windowWidth < DESKTOP_BREAKPOINT;
};
